import { lazy, Suspense } from 'react';

export function loadReactFlow() {
  return import(
    /* webpackChunkName: "reactflow" */
    /* webpackPrefetch: true */
    './Reactflow'
  ).then((module) => {
    // reactflow 貌似会在 ReactFlow 渲染完立即去遍历 Handle 的 dom node 寻找 edge 的位置，
    // 所以如果 Handle 被用 loadable lazy 的话会画不出线。
    // 因为 Handle 是在 custom node 里调用，一定在 ReactFlow 渲染过后才会调用，所以可以直接在这里赋值。
    AsyncReactFlow.Handle = module.Handle;
    return module;
  });
}

const LazyReactFlow = lazy(() => loadReactFlow().then((module) => ({ default: module.ReactFlow })));
const LazyControls = lazy(() => loadReactFlow().then((module) => ({ default: module.Controls })));
const LazyMiniMap = lazy(() => loadReactFlow().then((module) => ({ default: module.MiniMap })));
const LazyBackground = lazy(() =>
  loadReactFlow().then((module) => ({ default: module.Background })),
);

const AsyncReactFlow = {
  ReactFlow(props) {
    return (
      <Suspense fallback={null}>
        <LazyReactFlow {...props} />
      </Suspense>
    );
  },
  Controls(props) {
    return (
      <Suspense fallback={null}>
        <LazyControls {...props} />
      </Suspense>
    );
  },
  MiniMap(props) {
    return (
      <Suspense fallback={null}>
        <LazyMiniMap {...props} />
      </Suspense>
    );
  },
  Background(props) {
    return (
      <Suspense fallback={null}>
        <LazyBackground {...props} />
      </Suspense>
    );
  },
  // Handle: 会在 loadReactFlow() resolve 后赋值
};

export default AsyncReactFlow;
